
import React from "react";
import ReactDOM from 'react-dom';
import GLightbox from "glightbox";
import Swiper from 'swiper/bundle';
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

// import '../scss/main.scss';

// alert("HUHU");

function toArray(obj) {
    var array = [];
    // iterate backwards ensuring that length is an UInt32
    for (var i = obj.length >>> 0; i--;) {
        array[i] = obj[i];
    }
    return array;
}

window.addEventListener("scroll", function () {
    if (document.getElementsByClassName("stage_slide").length) {
        var scrollpos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        var pos = scrollpos / 2;

        var els = document.getElementsByClassName("stage_slide");
        Array.prototype.forEach.call(els, function (el) {
            Array.prototype.forEach.call(el.childNodes, function (child) {
                if (child.tagName == "IMG") {
                    child.style.transform = "translate3d(0, " + pos + "px, 0)";

                }
                if (child.classList && child.classList.contains("stage_logo")) {
                    child.style.transform = "translate3d(0, " + pos * 0.5 + "px, 0)";
                }
            });
        });
    }
});

document.getElementById("mainnav-toggle").addEventListener("click", function () {
    document.body.classList.toggle("nav--open");
})

if (document.getElementById("sitenav-toggle")) {
    document.getElementById("sitenav-toggle").addEventListener("click", function () {
        this.parentNode.classList.toggle("nav--open");
    })
}


// let artroot = null;

// function hashChange() {
//     var location = window.location.hash.replace(/^#\/?|\/$/g, '');
//     var application = <ArtSearch location={location} url={artroot.getAttribute("data-url")} filterurl={artroot.getAttribute("data-filters")} />;
//     const root = createRoot(document.getElementById('artworkroot'));
//     root.render(application);
// }


// if (document.getElementById('artworkroot')) {
//     // Split location into `/` separated parts, then render `Application` with it
//     artroot = document.getElementById('artworkroot');

//     // Handle the initial route and browser navigation events
//     hashChange();
//     window.addEventListener('hashchange', hashChange, false);
// }

// Sommerbrise, ignore for now
// const events = document.querySelectorAll('[data-behaviour="event"]');
// events.forEach(event => {
//     const content = event.querySelector('.event_content');
//     autoAnimate(content);
//     const header = event.querySelector('.event_header h2');
//     const footer = event.querySelector('.event_footer');
//     const details = event.querySelector('.event_details');
//     const moreLink = event.querySelector('.event_more');
//     [header, moreLink].forEach((link) => {
//         link.addEventListener("click", function () {
//             event.classList.toggle('event--showdetails');
//             if (event.classList.contains('event--showdetails')) {
//                 content.insertBefore(details.cloneNode(true), footer);
//                 moreLink.innerHTML = "Weniger";
//             } else {
//                 const duplicate = event.querySelector('.event_content > .event_details');
//                 duplicate.remove();
//                 moreLink.innerHTML = "Mehr";
//             }
//         })
//     })
// })

const lightbox = GLightbox({
    selector: '[data-gallery="gallery"]',
    touchNavigation: true,
    loop: true,
});

import Loader from './loader.jsx';
import FilterableList from './components/FilterableList/FilterableList.jsx';
import KunstOrteList from './components/KunstOrteList/KunstOrteList.jsx';
import SmartEntdeckenList from './components/SmartEntdeckenList/SmartEntdeckenList.jsx';
import SmallMap from './components/SmallMap/SmallMap.jsx';
import autoAnimate from "@formkit/auto-animate";
import MapElement from './map/MapElement.jsx';
import CulturalPlaceList from "./components/CulturalPlaceList/CulturalPlaceList.jsx";
import ArtSearchComponent from "./components/ArtListComponent/ArtSearchComponent.jsx";
import { createRoot } from "react-dom/client";

const loader = new Loader();

loader.register('FilterableList', FilterableList);
loader.register('KunstOrteList', KunstOrteList);
loader.register('CulturalPlaceList', CulturalPlaceList);
loader.register('SmartEntdeckenList', SmartEntdeckenList);
loader.register('SmallMap', SmallMap);
loader.register('ArtSearchComponent', ArtSearchComponent);

loader.init(window.document);

document.addEventListener('DOMContentLoaded', function () {
    const digicultList = document.querySelector('[data-behaviour="digicult-list"]');
    if (digicultList) {
        const filterSelects = digicultList.querySelectorAll('select');
        filterSelects.forEach(select => {
            select.addEventListener('change', function () {
                const form = this.closest('form');
                form.submit();
            });
        })
    }


    // INIT SWIPER
    const sliders = document.querySelectorAll('.swiper');
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const autoplayButton = slider.querySelector('.swiper-pausebutton');

        if (autoplayButton) {
            const swiper = new Swiper(slider, {
                // configure Swiper to use modules
                modules: [Pagination, Navigation, Autoplay, EffectFade],
                effect: 'slide',
                autoplay: {
                    delay: 3000,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: true,
                },
                fadeEffect: {
                    crossFade: true
                },
                direction: 'horizontal',
                loop: true,

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
            });
            //window.swiper = swiper;

            autoplayButton.addEventListener('click', function () {
                //console.log(swiper);
                if (swiper.autoplay.running) {
                    //console.log("Stopping autoplay");
                    swiper.autoplay.stop();
                    autoplayButton.classList.add('swiper-pausebutton--paused');
                } else {
                    //console.log("Starting autoplay");
                    swiper.autoplay.start();
                    autoplayButton.classList.remove('swiper-pausebutton--paused');
                }
            });
        } else {
            const swiper = new Swiper(slider, {
                // configure Swiper to use modules
                modules: [Pagination, Navigation, Autoplay, EffectFade],
                effect: 'slide',
                fadeEffect: {
                    crossFade: true
                },
                direction: 'horizontal',
                loop: true,

                autoplay: false,

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
            });
        }
    });
});
